// Phase 84.M.32 — Helper formatting "Còn N ngày" cho các tournament card/hero.
// Quy tắc:
//   • daysLeft < 0   → "Đang diễn ra" (đã quá ngày start mà status vẫn upcoming).
//   • daysLeft === 0 → "Hôm nay" (giải diễn ra hôm nay → tránh "Còn 0 ngày" gây hiểu lầm).
//   • daysLeft > 0   → "Còn N ngày".
//   • null/undefined → null (caller tự ẩn).
export function daysLeftLabel(daysLeft) {
  if (daysLeft === null || daysLeft === undefined || Number.isNaN(daysLeft)) return null;
  const n = Number(daysLeft);
  if (n < 0) return "Đang diễn ra";
  if (n === 0) return "Hôm nay";
  return `Còn ${n} ngày`;
}
